import { getApiUrl, request } from '@project-minerva/api'
import { InvigilationCentre } from '@project-minerva/typings'

const baseUrl = getApiUrl('helios', '/v1/centres')

export const searchVenues = (query: string, token: string) => {
  const url = `${baseUrl}/search?q=${query}&limit=50`
  return request<{ count: number; results: InvigilationCentre[] }>(url, { method: 'GET' }, token)
}
